import loaderReducer from "./loaderSlice";
import authReducer from "./authSlice";
import { combineReducers } from "redux";


const rootReducer = combineReducers({
    loader: loaderReducer,
    auth: authReducer
});

export default rootReducer;